import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	headerTitle: {
		id: 'autodev.confirmation-modal.header-title',
		defaultMessage: 'Generate code with another agent?',
		description:
			'This is the title of the confirmation modal that appears when the user attempts to start a new autodev agent when one is already running.',
	},
	warningText: {
		id: 'autodev.confirmation-modal.warning-text',
		defaultMessage:
			'Coding with another AI agent will delete the generated code you have available today.',
		description:
			'This is the warning text that appears in the confirmation modal when the user attempts to start a new autodev agent when one is already running.',
	},
	confirmationText: {
		id: 'autodev.confirmation-modal.confirmation-text',
		defaultMessage: 'Are you sure you want to restart coding with another agent?',
		description:
			'This is the confirmation text that appears in the confirmation modal when the user attempts to start a new autodev agent when one is already running.',
	},
	restartButtonText: {
		id: 'autodev.confirmation-modal.restart-button-text',
		defaultMessage: 'Restart code with another agent',
		description: 'This is the restart button text.',
	},
	cancelButtonText: {
		id: 'autodev.confirmation-modal.cancel-button-text',
		defaultMessage: 'Cancel',
		description: 'This is the cancel button text.',
	},
});
